export default __webpack_public_path__ + "static/media/Divya.593e526f.JPG";